module.exports = __webpack_public_path__ + "static/media/image-web-3.33aac17b.png";